import { getPublicConfig } from "@/shared/config/config"
import type { PermissionsResponse } from "@/shared/types/PermissionType"
import type { TokenProvider } from "../auth/tokenProvider"
import { ApiError } from "../errors/ApiError"
import { createHttpClient } from "../http/httpClient"
import type { TokenResponse, UserInfoType } from "./authApi.types"
import type { IAuthApi } from "./iAuthApi"

const { cmApiBaseUrl } = getPublicConfig()

export function createAuthApi(tokenProvider: TokenProvider): IAuthApi {
  const httpClient = createHttpClient(tokenProvider)

  const getUserInfo = async (): Promise<UserInfoType> => {
    try {
      const userInfo = await httpClient.getWithoutRedirect<UserInfoType>(`${cmApiBaseUrl}/auth/user`)
      return userInfo
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) {
        return {
          isAuthenticated: false,
          claims: null,
          username: null,
          email: null
        }
      }
      throw new Error("Failed to get user info", { cause: error })
    }
  }

  const getUserPermissions = async (): Promise<PermissionsResponse> =>
    httpClient.get<PermissionsResponse>(`${cmApiBaseUrl}/auth/permissions`)

  const getToken = async (): Promise<TokenResponse> => httpClient.get<TokenResponse>(`${cmApiBaseUrl}/auth/token`)

  return { getUserInfo, getUserPermissions, getToken }
}
